<template>
    <div>
        <el-dialog
            v-drag
            class="add-lessthan-dialog"
            :append-to-body="true"
            :title="`新增零担对接平台`"
            :visible.sync="visible"
            width="500px"
            :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form ref="form" :disabled="operationType === 'detail'" :model="formData" size="mini" :rules="rules" label-width="110px">
                <el-form-item label="零担对接平台" prop="exchangePlatform">
                    <MSelect
                        optionNum="SRM_LESS_PLATFORM"
                        :value="formData.exchangePlatform"
                        @input="getSelectValue($event, 'exchangePlatform')"></MSelect>
                </el-form-item>
                <el-form-item label="专线名称" prop="accountName">
                    <el-input maxlength="100" v-model="formData.accountName"></el-input>
                </el-form-item>
                <el-form-item label="专线账号" prop="professionalAccount">
                    <el-input maxlength="100" v-model="formData.professionalAccount"></el-input>
                </el-form-item>
                <el-form-item label="专线KEY" prop="professionalKey">
                    <el-input maxlength="100" v-model="formData.professionalKey"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="enableFlag">
                    <MSelect
                        :optionArr="[
                            { label: '启用', value: 1 },
                            { label: '停用', value: 0 },
                        ]"
                        :value="formData.enableFlag"
                        @input="getSelectValue($event, 'enableFlag')"></MSelect>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <template v-if="operationType !== 'detail'">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button :loading="btnLoading" type="primary" @click="save">保 存</el-button>
                </template>
                <el-button v-else type="primary" @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import MSelect from '@/components/lots/otpSelect2'
import { dictWithUrl } from '@/components/lots/api'
import { supplierLessSystemCreateTemp } from '../api/changeDetails.js'
const INIT_FORM = {
    exchangePlatform: '',
    accountName: '',
    professionalAccount: '',
    professionalKey: '',
    enableFlag: '',
}

export default {
    components: { MSelect },
    props: {
        supplierCode: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            btnLoading: false,
            visible: false,
            formData: cloneDeep(INIT_FORM),
            rules: {
                exchangePlatform: [{ required: true, message: '请选择零担对接平台', trigger: ['blur', 'change'] }],
                accountName: [{ required: true, message: '请输入专线名称', trigger: ['blur', 'change'] }],
                professionalAccount: [{ required: true, message: '请输入专线账号', trigger: ['blur', 'change'] }],
                professionalKey: [{ required: true, message: '请输入专线KEY', trigger: ['blur', 'change'] }],
                enableFlag: [{ required: true, message: '请选择状态', trigger: ['blur', 'change'] }],
            },
            operationType: '',
        }
    },
    methods: {
        save() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    let params = {
                        ...this.formData,
                        supplierCode: this.supplierCode,
                    }
                    supplierLessSystemCreateTemp(params)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.handleClose()
                                this.$emit('validate', params, res.data)
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false
                        })
                }
            })
        },
        getSelectValue(v, prop) {
            this.formData[prop] = v
        },
        handleClose() {
            this.formData = cloneDeep(INIT_FORM)
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
            this.visible = false
        },
        init(row, type) {
            this.operationType = type
            if (row) {
                this.formData = {
                    ...row,
                }
            }
            this.visible = true
        },
    },
    mounted() {
        // dictWithUrl('BID_BUSINESS_TYPE').then(res => {
        //     if (res && +res.code === 0) {
        //         this.dict = res.data
        //     }
        // })
    },
}
</script>
<style lang="less" scoped>
.add-lessthan-dialog {
    /deep/ .el-form-item {
        margin-bottom: 27px;
    }
}
</style>
